<template>
  <div class="file-row__container">
    <div class="row">
      <div class="col">
        <span class="file-row__label">Nombre del Documento:</span>
        <br />
        <span>{{ documentName }}</span>
      </div>
      <div class="col">
        <span class="file-row__label">Archivo:</span>
        <br />
        <span>{{ documentFileName }}</span>
      </div>
      <div v-if="isProvisionalRemedyArea" class="col">
        <span class="file-row__label">
          Nombre del Evaluador:
        </span>
        <br />
        <span>{{ evaluatorName | empty }}</span>
      </div>
      <div v-if="isProvisionalRemedyArea" class="col">
        <span class="file-row__label">
          Usuario:
        </span>
        <br />
        <span>{{ createdBy | empty }}</span>
      </div>
      <div v-if="isProvisionalRemedyArea" class="col">
        <span class="file-row__label">
          Fecha:
        </span>
        <br />
        <span>{{ createdDate | date }}</span>
      </div>
      <div class="col d-flex align-items-end justify-content-end">
        <div v-if="!isShowingReplacement">
          <action-button
            class="action-button"
            i="action-icon fas fa-file-download"
            variant="success"
            @click="$emit('download')"
          />
          <action-button
            v-if="canReplace"
            class="action-button"
            i="action-icon fas fa-undo"
            variant="outline-success"
            @click="isShowingReplacement = true"
          />
          <action-button
            v-if="canRemoveDocument"
            id="btn-remove-doc"
            i="fa fa-times-circle mr-n1 pr-1"
            variant="outline-danger ml-1"
            @click="$emit('remove')"
          />
        </div>
      </div>
    </div>

    <DeterminationFileUpload
      v-if="isShowingReplacement"
      :id="documentId"
      :evaluator-name="evaluatorName"
      :name="documentName"
      @cancel="isShowingReplacement = false"
      @upload="replace"
    />
  </div>
</template>
<script>
import ActionButton from 'ActionButton';
import DeterminationFileUpload from './DeterminationFileUpload.vue';

export default {
  name: 'DeterminationFileRow',
  components: {
    ActionButton,
    DeterminationFileUpload,
  },
  props: {
    documentId: {
      type: String,
      default: '',
    },
    documentName: {
      type: String,
      default: '',
    },
    evaluatorName: {
      type: String,
      default: '',
    },
    createdBy: {
      type: String,
      default: '',
    },
    createdDate: {
      type: String,
      default: '',
    },
    documentFileName: {
      type: String,
      default: '',
    },
    canReplace: {
      type: Boolean,
      default: false,
    },
    canRemoveDocument: {
      type: Boolean,
      default: false,
    },
    isProvisionalRemedyArea: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isShowingReplacement: false,
  }),
  methods: {
    replace(data) {
      this.isShowingReplacement = false;
      this.$emit('replace', data);
    },
  },
};
</script>
<style>
.file-row__container {
  background-color: #f7f7f7;
  border-radius: 2px;
  padding: 15px;
  margin-bottom: 10px;
}
.file-row__label {
  font-size: 14px;
  color: gray;
}
.action-icon {
  padding: 0 !important;
  margin: 0 !important;
}
.action-button {
  margin: 0 5px;
}
</style>
